import { siteId as defaultSiteId } from "Selectors/DashboardSelector"
import { getStartDate, getEndDate } from 'Utils/MomentHelpers';

const create = (api) => {
  const getBatteriesWithCycleCard = (startDate = getStartDate(), endDate = getEndDate(), siteId = defaultSiteId, countAbove = 500) => {
    return api.get(`/dashboard/batteryhealth/dashboardcyclecount/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCount=${countAbove}`)
  }

  const getBatteriesWithCycleDetails = (startDate = getStartDate(), endDate = getEndDate(), siteId = defaultSiteId, cycleCount=500, params = {}, pageNumber = 1, pageSize = 100) => {
    const query = (params.searchTerm === null || params.searchTerm === undefined) ? `&query=` : `&query=${params.searchTerm}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    return api.get(`/dashboard/batteryhealth/cyclecount/details/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCount=${cycleCount}&includeChildren=true&pageNumber=${pageNumber}&pageSize=${pageSize}`+ `${query}` + `${sort}` + `${directionSort}` + `${language}`)

  }

  const getExportDeviceCVSFile = (siteId = defaultSiteId, payload = {}, params = {}, startDate = getStartDate(), endDate = getEndDate()) =>
          api.post(`/dashboard/exportfiles/${siteId}?startDate=${startDate}&endDate=${endDate}`, payload, { params });

  return {
    getBatteriesWithCycleCard,
    getBatteriesWithCycleDetails,
    getExportDeviceCVSFile
  }
}

export default {
  create
}